export const COMPANY_UPDATE_DRAWER_HELPER = 'All Company Updates are posted on the home feed';
